// JavaScript para mostrar el botón al hacer scroll
window.onscroll = function () {
  const btn = document.querySelector(".scroll-to-top");
  if (!btn) return; // Asegúrate de que el botón existe
  if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
    btn.style.display = "block";
  } else {
    btn.style.display = "none";
  }
};

// Función global para subir al inicio
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
window.scrollToTop = scrollToTop;

// Ejecutar solo cuando el DOM esté completamente cargado
document.addEventListener('DOMContentLoaded', function () {
  const btnCookies = document.getElementById('btn-config-cookies');
  if (!btnCookies) return;

  btnCookies.addEventListener('click', function () {
    const form = document.getElementById('cookie-form');
    if (!form) return;

    // Leer del localStorage (devuelve string, por eso comparamos con 'true')
    form.analytics.checked = localStorage.getItem('cookies_analytics') === 'true';
    form.marketing.checked = localStorage.getItem('cookies_marketing') === 'true';

    const modal = document.getElementById('modalCookies');
    if (modal) modal.style.display = 'block';
  });
});
